import { guideIconHtml } from "@scalar-org/guide-icons";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { validate } from "../../helpers/validate.js";
import { attributesIconSchema } from "./attributes.js";
const scalarIcon = {
  name: "scalar-icon",
  tagName: "scalar-icon",
  tiptapName: "custom_icon",
  attributeTransform: (content, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    const classNames = Array.isArray(attrs.className) ? attrs.className : void 0;
    const validated = validate(attributesIconSchema, {
      ...attrs,
      caption: attrs.caption || content,
      class: classNames?.join(" "),
      ...(attrs.width || attrs.height) && { size: "custom" }
    });
    return validated;
  },
  render: async (props) => {
    return await guideIconHtml({
      src: props.src,
      title: props.title,
      classes: props.class?.split(" "),
      size: props.size
    });
  }
};
export {
  scalarIcon
};
//# sourceMappingURL=index.js.map
